// /var/www/afra/web-design.rampagesoft.com/my-app/src/App.js

import React from "react";
// ลบ useParams ที่ไม่ได้ใช้ออกจาก App.js (ถ้า ContentDetailWithMeta ถูกลบ)
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./css/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/main.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./css/rampagesoft.css";
import Menu from "./menu";
import MetaTagCRM from "./meta-tag-crm";
import Footer from "./footer";
import CRM from "./page/CRM.js";
import Ecomm from "./page/Ecomm.js";
import HomeIndex from "./page/HomeIndex";
import WebDesign from "./page/WebDesign";
import Content from "./page/Content.js";
import ContentDetail from "./component/ContentDetail";
// ไม่จำเป็นต้อง import MetaTagContentDetail หรือ useParams ที่นี่อีกต่อไป หาก ContentDetailWithMeta ถูกลบ

// ลบ ContentDetailWithMeta ทั้งหมดออก หรือแก้ไขดังนี้ (แต่แนะนำให้ลบ)
/*
// แบบแก้ไข (ไม่แนะนำเท่าลบแล้วเรียก ContentDetail ตรงๆ):
const ContentDetailWithMeta = () => {
  // Wrapper นี้จะไม่ render MetaTagContentDetail เอง
  return <ContentDetail />;
};
*/

function App() {
  return (
    <Router basename="/">
      <div>
        <header>
          <Menu />
        </header>
        <main>
          <Routes>
            <Route path="/" element={<HomeIndex />} />
            <Route path="/webdesign" element={<WebDesign />} />
            <Route path="/crm" element={
              <>
                <MetaTagCRM />
                <CRM />
              </>
            } />
            <Route path="/ecomm" element={<Ecomm />} />
            <Route path="/content" element={<Content />} />
            {/* แก้ไขตรงนี้: ให้ Route เรียก ContentDetail โดยตรง */}
            <Route path="/content/:id/*" element={<ContentDetail />} />
            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;